//temporary place holder for navigation

import { RootState } from "app/store";
import ComparisonNavbar from "components/layout/ComparisonNavbar";
import { EViewType } from "global/Application";
import { appInsights } from "global/Application/AppInsight";
import { setViewType } from "global/Reducer/statusSlice";
import * as IRedirects from 'model/Redirect.type';
import { useEffect, useState } from "react";
import { connect, ConnectedProps, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import EntryDialog from "./EntryDialog";


interface IProps extends TComponentConnectedProps {
}

const BlueRelationship = (props: IProps) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const [redirectRequest, setRedirectRequest] = useState<IRedirects.TRedirectRequest | null>(null);

    //TODO for now until things settle and are finalized.
    useEffect(() => {
        document.title = 'BlueRelationship';

        (async _ => {
            try {
                const redirected = props?.state?.router.location.query as IRedirects.TRedirectRequest;
                setRedirectRequest(redirected);
            } catch (error) {

            }
            finally {
            }
        })();

    }, []);

    const renderDialog = () => {

        if (!props.state.status.viewType)
            return (
                <EntryDialog
                    variant={
                        redirectRequest?.accountId
                            ? "view-multiple-config"
                            : "default"
                    }
                    onConfirm={(action) => {
                        
                        if (redirectRequest){
                            
                            appInsights?.trackEvent({
                                name: 'BlueRelationship.EntryDialog.onConfirm',
                                properties: {
                                    action: action,
                                }
                            });
                        
                            if (action === "compare") {
                                dispatch(setViewType(EViewType.ViewOnly))
                                const link = `/comparison/${redirectRequest.accountId}/${redirectRequest.snapshot1Id}/${redirectRequest.snapshot2Id}`
                                history.push(link);
                            }
                            else if (action === "merge") {
                                dispatch(setViewType(EViewType.ViewOnly))
                                const link = `/merge/${redirectRequest.accountId}/${redirectRequest.snapshot1Id}/${redirectRequest.snapshot2Id}`
                                history.push(link);
                            }
                            else if (action === "underwriting review") {
                                dispatch(setViewType(EViewType.ViewOnly))
                                const link = `/underwritingReview/${redirectRequest.accountId}/${redirectRequest.snapshot1Id}/${redirectRequest.snapshot2Id}`
                                history.push(link);
                            }
                        }
                    }}
                />
            );
    }

    return (
        <div>
            <ComparisonNavbar />
            {props?.state?.status?.account?.name}
            {renderDialog()}

        </div>
    );
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(BlueRelationship);